/* eslint-disable camelcase */

import {isDefined} from '../../../libs/shared/helpers/src/typescript/typeHelpers';
import {CommonSchema} from '../../models/api/integrationTypesModel';
import {Parameter, ParameterId} from '../editors/commons/parameterModel';
import {RuleActionTypesEnum} from './ruleActionModel';
import {RuleConditionTypesEnum} from './ruleConditionModel';

export type IntegrationId = number & {_type: 'IntegrationId'};

export function makeIntegrationId(id: number): IntegrationId {
  return id as IntegrationId;
}

export type ValidateFunction = (params: object) => ReadonlyArray<{
  path: string;
  keyword: string;
  message?: string;
}>;

interface BaseStatementDefinition<T> {
  id: T;
  name: string;
  altName?: string;
  tooltip?: string;
  integration_id: IntegrationId; // @TODO: Rename to integrationId.
  parameters: Record<ParameterId, Parameter>;
  resolvedParameters: Partial<Record<ParameterId, CommonSchema>>;
  defaultParams: any; // @TODO: Better typings.
  validate: ValidateFunction;
  required?: ReadonlyArray<ParameterId>;
  restricted?: ReadonlyArray<string>; // 'global', 'tea', 'tim'...
  help?: {
    text: string;
    link: string;
  };
}

export type RuleConditionId = RuleConditionTypesEnum & {_type: 'RuleConditionId'};

export function makeRuleConditionId(id: string) {
  return id as RuleConditionId;
}

export type RuleConditionDefinition = BaseStatementDefinition<RuleConditionId>;

export type RuleActionId = RuleActionTypesEnum & {_type: 'RuleActionId'};

export function makeRuleActionId(id: string) {
  return id as RuleActionId;
}

export type RuleActionDefinition = BaseStatementDefinition<RuleActionId>;

export function isStatementDefinition<T>(item: any): item is BaseStatementDefinition<T> {
  return Boolean(item && isDefined(item.integration_id));
}
